module.exports = __webpack_public_path__ + "static/media/DJI_0614.c0dccd35.JPG";